<script>
	import { popupModalOpen } from '$lib/popups/popupsStore';
	import { orbTweetContent } from '$lib/tradingSeason/constants';
	import { levelClaimedInModal } from '$lib/tradingSeason/store';

	const handleCloseModal = () => {
		popupModalOpen.set(false);
	};

	const handleTweetClick = () => {
		// TODO, confirm the content to tweet
		window.open(`https://twitter.com/share?${orbTweetContent}`, '_blank');
	};
</script>

<div
	class="w-[308px] flex p-5 flex-col items-center gap-6 justify-center rounded-2xl border-[1px] border-solid border-fx-grey-500 bg-fx-gradient-8 overflow-hidden"
>
	<div
		class={`w-full flex justify-center items-center flex-col pt-2 pb-4 z-10 relative border border-[#262626] rounded-2xl bg-fx-gradient-level-${$levelClaimedInModal}-card`}
	>
		<img
			src={`trading-season/TraderBadgesSection/levels/level-${$levelClaimedInModal}.webp`}
			alt={`Level ${$levelClaimedInModal}`}
			loading="lazy"
			class="w-full mb-1"
		/>
		<p class="text-xs text-fx-grey-400 text-center mb-2">
			Congratulations! 🏆 <br />
			You’ve claimed Level {$levelClaimedInModal} NFT.
		</p>
		<p class="text-fx-gradient-17 text-2xl leading-[30px] font-semibold">
			Level {$levelClaimedInModal}
		</p>
		<img
			src="trading-season/TraderBadgesSection/bg-pattern.webp"
			alt="Bg Pattern"
			class="absolute top-0 z-0"
		/>
	</div>
	<div class="h-[1px] bg-fx-grey-600 w-full" />
	<div class="flex justify-center items-center w-full gap-2.5">
		<button
			class="w-full bg-fx-gradient-5 rounded-xl flex justify-center items-center py-[18px]"
			on:click={handleCloseModal}
		>
			<p class="text-base font-semibold text-fx-black">Go Back</p>
		</button>
		<button
			class="w-full bg-fx-black border border-fx-grey-400 rounded-xl flex justify-center items-center gap-0.5 py-[18px]"
			on:click={handleTweetClick}
		>
			<p class="text-base font-semibold text-fx-white">🎉 Share on</p>
			<img src="trading-season/x.webp" alt="X" class="w-5 h-5 -mt-0.5" />
		</button>
	</div>
</div>
